import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { PageStyleLoaderSymbol } from '../symbols'
import { PageAssetsLoader } from './dsPageAssetsLoader'
import { ILoadPageStyle } from '../PageStyleLoader'
import { IPageAssetsLoader, PageAssetsLoaderSymbol } from '@wix/thunderbolt-symbols'

export const editor: ContainerModuleLoader = (bind) => {
	bind<IPageAssetsLoader>(PageAssetsLoaderSymbol).to(PageAssetsLoader)
	bind<ILoadPageStyle>(PageStyleLoaderSymbol).toConstantValue({
		load: () => Promise.resolve(),
	})
}
